import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bulb"
const BulbIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 6.75C15.314 6.75 18 9.436 18 12.75 18 14.972 16.792 16.908 15 17.945V21C15 21.83 14.327 22.5 13.5 22.5H10.5C9.67 22.5 9 21.828 9 21V17.945C7.208 16.908 6 14.972 6 12.75 6 9.436 8.686 6.75 12 6.75M12 8.25C9.515 8.25 7.5 10.265 7.5 12.75 7.5 14.543 8.55 16.093 10.072 16.816L10.5 17.02V18.75H13.5V17.02L13.928 16.816C15.45 16.093 16.5 14.544 16.5 12.75 16.5 10.265 14.485 8.25 12 8.25"
            clipRule="evenodd"
          />
          <path d="M4.5 13.5H1.5V12H4.5zM22.509 12 22.49 13.5 19.197 13.463 19.214 11.963zM7.36 7.334 6.3 8.394 3.647 5.743 4.71 4.683zM20.485 5.743 17.834 8.394 16.774 7.334 19.423 4.682zM12.75 5.25H11.25V1.5H12.75z" />
        </svg>
      }
    </span>
  )
}
export default BulbIcon
